module.exports = __webpack_public_path__ + "static/010.thumb-811876384a61cf5e0e22e191822ef131.jpg";